import React from 'react';

const Heart = () => {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6855 2.45916C12.4838 1.97793 12.1929 1.54185 11.8292 1.17532C11.4653 0.807695 11.0362 0.51555 10.5652 0.31477C10.0769 0.105747 9.5531 -0.0012432 9.0243 1.08985e-05C8.28243 1.08985e-05 7.55862 0.209333 6.92961 0.60472C6.77913 0.699303 6.63618 0.803189 6.50074 0.916378C6.36531 0.803189 6.22236 0.699303 6.07188 0.60472C5.44287 0.209333 4.71906 1.08985e-05 3.97719 1.08985e-05C3.44299 1.08985e-05 2.92533 0.105447 2.43627 0.31477C1.96377 0.51634 1.53791 0.80629 1.17224 1.17532C0.808074 1.54143 0.517167 1.97762 0.316008 2.45916C0.106841 2.95999 0 3.49182 0 4.03916C0 4.55549 0.102327 5.09352 0.305475 5.64086C0.475517 6.09827 0.719295 6.57273 1.03079 7.05185C1.52436 7.81006 2.20303 8.60084 3.04572 9.40246C4.44218 10.7313 5.82509 11.6492 5.88378 11.6864L6.24041 11.9221C6.39842 12.026 6.60157 12.026 6.75957 11.9221L7.11621 11.6864C7.1749 11.6476 8.5563 10.7313 9.95426 9.40246C10.797 8.60084 11.4756 7.81006 11.9692 7.05185C12.2807 6.57273 12.526 6.09827 12.6945 5.64086C12.8977 5.09352 13 4.55549 13 4.03916C13.0015 3.49182 12.8946 2.95999 12.6855 2.45916Z"
        fill="#E94949"
      />
    </svg>
  );
};

export default Heart;
